import {
	AfterViewInit,
	ComponentFactoryResolver, ComponentRef,
	Directive,
	ElementRef, Inject, Input,
	OnDestroy, Type,
	ViewContainerRef
} from "@angular/core";
import {DOCUMENT} from "@angular/common";
// import {TitleTooltipContentComponent} from "../../components/title.tooltip/title.tooltip.content.component";
// import {TitleTooltipComponent} from "../../components/title.tooltip/title.tooltip.component";

@Directive({
	selector: '[cpTitleTooltip]'
})
export class TitleTooltipDirective implements AfterViewInit, OnDestroy {

	@Input() titleText: string;
	@Input() titleTextSecondary: string;

	// private contentComponentRef: ComponentRef<TitleTooltipContentComponent>;
	// private titleComponentRef: ComponentRef<TitleTooltipComponent>;

	constructor(protected componentFactoryResolver: ComponentFactoryResolver,
				protected target:ViewContainerRef) {
		//protected el: ElementRef,
		//@Inject(DOCUMENT) protected document:Document
	}

	ngAfterViewInit(): void {
		this.insertTooltipComponent();
	}

	ngOnDestroy(): void {
		// if (this.contentComponentRef) {
		// 	this.contentComponentRef.destroy();
		// }
		//
		// if (this.titleComponentRef) {
		// 	this.titleComponentRef.destroy();
		// }
	}

	protected insertTooltipComponent(forceEmpty:boolean=false) {
		if (!this.titleText && !forceEmpty) { //There is no title text to show
			return;
		}

		if (this.target && this.target.element && this.target.element.nativeElement) {
			this.target.element.nativeElement.title = (this.titleText??"") + (this.titleTextSecondary ? "  (" + this.titleTextSecondary + ")" : "");
		}

		// let contentComponent = this.createComponent(TitleTooltipContentComponent);
		// contentComponent.instance.textMain = this.titleText;
		// contentComponent.instance.textSecondary = this.titleTextSecondary || '';
		// contentComponent.changeDetectorRef.detectChanges();
		//
		// let tooltipComponent = this.createComponent(TitleTooltipComponent, [contentComponent.hostView["rootNodes"]]);
		// tooltipComponent.instance.anchor = this.el.nativeElement;
		// tooltipComponent.changeDetectorRef.detectChanges();
		//
		// this.target.insert(tooltipComponent.hostView);
		//
		// //save reference fot the dynamically created component for the onDestroy
		// this.contentComponentRef = contentComponent;
		// this.titleComponentRef = tooltipComponent;
	}

	// private createComponent<T>(componentType: Type<T>, projectableNodes?: any[][]): ComponentRef<T> {
	// 	const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
	// 	let component = factory.create(this.target.injector, projectableNodes);
	//
	// 	return component;
	// }
}
